import React from 'react';
import { Search, X } from 'lucide-react';
import { AdminHierarchyFilters } from '../../hooks/useAdminHierarchyFilters';
import { Select } from '../ui/Select';

interface EstadoOption {
  value: string;
  label: string;
}

interface Props {
  filters: AdminHierarchyFilters;
  searchPlaceholder: string;
  searchLabel: string;
  estadoOptions: EstadoOption[];
}

export const AdminFiltersPanel: React.FC<Props> = ({
  filters,
  searchPlaceholder,
  searchLabel,
  estadoOptions,
}) => {
  const {
    filterProvincia, filterDiocesis, filterLumisial, filterEstado, filterBusqueda,
    setFilterProvincia, setFilterDiocesis, setFilterLumisial, setFilterEstado, setFilterBusqueda,
    resetFilters, hasActiveFilters,
    isGlobal, isNacional,
    provinciasEclesiasticas, diocesisList, lumisialesList,
  } = filters;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">Filtros</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {isGlobal && (
          <div>
            <Select
              label="Provincia Eclesiástica"
              options={provinciasEclesiasticas.map((p) => ({ value: p.id, label: p.nombre }))}
              value={filterProvincia}
              onChange={(v) => { setFilterProvincia(v); setFilterDiocesis(''); setFilterLumisial(''); }}
              placeholder="Todas las provincias"
            />
          </div>
        )}

        {(isGlobal || isNacional) && (
          <div>
            <Select
              label="Diócesis"
              options={diocesisList.map((d) => ({ value: d.id, label: d.nombre }))}
              value={filterDiocesis}
              onChange={(v) => { setFilterDiocesis(v); setFilterLumisial(''); }}
              placeholder="Todas las diócesis"
              disabled={isGlobal && !filterProvincia}
            />
          </div>
        )}

        <div>
          <Select
            label="Sede"
            options={lumisialesList.map((l) => ({ value: l.id, label: l.nombre }))}
            value={filterLumisial}
            onChange={(v) => setFilterLumisial(v)}
            placeholder="Todas las sedes"
          />
        </div>

        <div>
          <Select
            label="Estado"
            options={estadoOptions.map((opt) => ({ value: opt.value, label: opt.label }))}
            value={filterEstado}
            onChange={(v) => setFilterEstado(v)}
            placeholder="Todos los estados"
          />
        </div>

        <div className="sm:col-span-2 lg:col-span-full">
          <label className="block text-xs font-medium text-slate-600 mb-1">{searchLabel}</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              value={filterBusqueda}
              onChange={(e) => setFilterBusqueda(e.target.value)}
              placeholder={searchPlaceholder}
              className="w-full pl-9 pr-4 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            />
            {filterBusqueda && (
              <button
                onClick={() => setFilterBusqueda('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>

      {hasActiveFilters && (
        <div className="mt-3 pt-3 border-t border-slate-100">
          <button
            onClick={resetFilters}
            className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700"
          >
            <X className="w-4 h-4" />
            Limpiar filtros
          </button>
        </div>
      )}
    </div>
  );
};
